import { connect } from 'react-redux';
import CsvDownloadButton from '../../../components/navigation/csv/CsvDownloadButton';

const mapDispatchToProps = (dispatch, { clickHandler }) => {
  return {
    onClick: () => dispatch(clickHandler()),
  };
};

export default connect(null, mapDispatchToProps)(CsvDownloadButton);
